// material ui
import { alpha, Chip, Tooltip } from '@mui/material';

const getTrendColor = (percentage) => {
  // For energy consumption: negative change = good (decreased), positive = bad (increased)
  if (percentage < 0) {
    return 'success'; // Green for negative (consumption decreased)
  } else if (percentage > 0) {
    return 'error'; // Red for positive (consumption increased)
  } else {
    return 'warning'; // Grey for no change
  }
};

const PercentageTrendChip = ({ value, tooltip = '', showArrow = false }) => {
  const arrow = showArrow ? (value < 0 ? '↓' : value > 0 ? '↑' : '→') : '';
  const chip = (
    <Chip
      variant="filled"
      sx={{
        marginLeft: 1,
        borderRadius: 2,
        backgroundColor: (theme) =>
          alpha(theme.palette[getTrendColor(value)].main, 0.1),
        color: (theme) =>
          theme.palette.mode === 'light'
            ? theme.palette[getTrendColor(value)].dark
            : theme.palette[getTrendColor(value)].light,
      }}
      label={value ? `${arrow} ${value.toFixed(1)}%` : ` ${arrow} 0%`}
      size="small"
    />
  );

  if (tooltip) {
    return <Tooltip title={tooltip}>{chip}</Tooltip>;
  }

  return chip;
};

export default PercentageTrendChip;
